import { useState, useEffect, useCallback } from 'react'
import { gameApi } from '../api/endpoints'
import type { MorseStatus, MorseGuessResult } from '../types'

export function useMorse() {
  const [status, setStatus] = useState<MorseStatus | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchStatus = useCallback(async () => {
    try {
      setLoading(true)
      setError(null)
      const data = await gameApi.getMorseStatus()
      setStatus(data)
    } catch (err: any) {
      setError(err.response?.data?.message || 'خطا در بارگذاری بازی مورس')
    } finally {
      setLoading(false)
    }
  }, [])

  const start = useCallback(async () => {
    try {
      setError(null)
      const data = await gameApi.startMorse()
      setStatus(data)
      return data
    } catch (err: any) {
      setError(err.response?.data?.message || 'خطا در شروع بازی')
      return null
    }
  }, [])

  const guess = useCallback(async (word: string): Promise<MorseGuessResult | null> => {
    try {
      setError(null)
      const result = await gameApi.guessMorse(word)
      await fetchStatus()
      return result
    } catch (err: any) {
      setError(err.response?.data?.message || 'خطا در ثبت حدس')
      return null
    }
  }, [fetchStatus])

  useEffect(() => {
    fetchStatus()
  }, [fetchStatus])

  return { status, loading, error, start, guess, refetch: fetchStatus, setError }
}
